import { FormStepType } from "../types";
import {
  docType,
  status,
  firstName,
  lastName,
  issuanceDateNewPassportOptional,
  issuanceDateNewPassportRequired,
  documentNumberNewPassportRequired,
  documentNumberNewPassportOptional,
} from "./fields/passport-details-fields";
import { travelPlansGroup } from "./fields/travel-plans-fields";

export const passport_details_new: FormStepType = {
  id: 3,
  name: "passport-details",
  title: "3. Passport Details",
  groups: [
    {
      name: "issued-documents",
      fields: [docType({ form: "new-passport" })],
      subGroups: [
        {
          name: "passport-book",
          title: "U.S Passport Book",
          subTitle: "Your name as printed on your most recent U.S. Passport book",
          condition: {
            field: "documentType2",
            values: ["passportbook", "both"],
          },
          fields: [
            status({}),
            issuanceDateNewPassportRequired({}),
            issuanceDateNewPassportOptional({}),
            firstName({}),
            lastName({}),
            documentNumberNewPassportRequired({}),
            documentNumberNewPassportOptional({}),
          ],
          cols: 6,
        },
        {
          name: "passport-card",
          title: "U.S Passport Card",
          subTitle: "Your name as printed on your most recent U.S. Passport card",
          condition: {
            field: "documentType2",
            values: ["passportcard", "both"],
          },
          fields: [
            status({ type: "card" }),
            issuanceDateNewPassportRequired({ type: "card" }),
            issuanceDateNewPassportOptional({ type: "card" }),
            firstName({ type: "card" }),
            lastName({ type: "card" }),
            documentNumberNewPassportRequired({ type: "card" }),
            documentNumberNewPassportOptional({ type: "card" }),
          ],
          cols: 6,
        },
      ],
    },
    travelPlansGroup,
  ],
};
